const dialog = {
    CHANGE: 'CHANGE_ORDER',
    CANCEL: 'CANCEL_ORDER',
};

const view = {
    OPTIONS: 'OPTIONS',
    DELIVERY_WINDOW: 'DELIVERY_WINDOW',
};

class OrderManagementActionsPendingController {
    constructor($scope, $state, $rootScope, orderManagementService, trolleyService, pastShopService, dialogRegistry, moveFocus) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.orderManagementService = orderManagementService;
        this.trolleyService = trolleyService;
        this.pastShopService = pastShopService;
        this.dialogRegistry = dialogRegistry;
        this.moveFocus = moveFocus;

        this.view = view;
        this.dialog = dialog;
    }

    $onInit() {
        this.currentView = this.view.OPTIONS;
    }

    setView(newView) {
        this.currentView = newView;
    }

    onActionClick() {
        this.moveFocus('#body-container');
        this.itemCtrl.setView('DETAILS');
    }

    cancelDialog(currentDialog) {
        this.moveFocus(`._${currentDialog}`);
    }

    changeOrder() {
        const changeDialog = this.dialogRegistry.getDialog(this.dialog.CHANGE);
        if (changeDialog) {
            changeDialog.show()
                .then(() => {
                    this.orderManagementService.changeOrder(this.order.OrderId).then(() => {
                        this.pastShopService.invalidate();
                        this.$rootScope.$broadcast('order-change');

                        this.trolleyService.getTrolley().then(() =>
                            this.$rootScope.$broadcast('trolley:update'));

                        // TO CONFIRM: don't really know if they still want this redirect
                        if (this.$state.is('shop.confirmation')) {
                            window.location.href = '/';
                        }
                    });
                });
        }
    }

    cancelOrder() {
        const cancelDialog = this.dialogRegistry.getDialog(this.dialog.CANCEL);
        if (cancelDialog) {
            cancelDialog.show()
                .then(() => {
                    this.orderManagementService.cancelOrder(this.order.OrderId).then(() => {
                        this.pastShopService.invalidate();
                        this.$scope.$emit('order-cancel');

                        // TO CONFIRM: don't really know if they still want this redirect
                        this.$state.go('shop.confirmation', { orderId: this.order.OrderId }, { reload: true });
                    });
                });
        }
    }
}

const orderManagementActionsPendingComponentDefinition = {
    bindings: {
        order: '<',
    },
    require: {
        itemCtrl: '^wowOrderManagementItem',
    },
    controller: ['$scope', '$state', '$rootScope', 'OrderManagementService', 'TrolleyService', 'PastShopService', 'DialogRegistry', 'MoveFocus', OrderManagementActionsPendingController],
    template: require('./order-management-actions-pending.component.html').trim(),
};

module.exports = {
    OrderManagementActionsPendingController,
    orderManagementActionsPendingComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management-actions-pending.component.js